import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ThemeService } from '@wind-log_library/fe-component-library';

@Component({
    selector: 'app-signals-chart-y-axis-popup',
    templateUrl: './signals-chart-y-axis-popup.component.html',
    styleUrls: ['./signals-chart-y-axis-popup.component.scss'],
    standalone: false
})

export class SignalsChartYAxisPopupComponent implements OnInit {

  public subject: Subject<any>;
  public theme$: Observable<string>;
  public originalYAxisData: {min: number, max: number, title: string, locked?: boolean}[];
  public yAxisData: {min: number, max: number, title: string, locked?: boolean}[];

  constructor(public bsModalRef: BsModalRef, public themeService: ThemeService) {}

  ngOnInit(): void {}
  
  public cancel(): void {
    this.bsModalRef.hide();
    this.subject.next({custom: false, cancel: true, yaxis: []});
    this.subject.complete();
  }

  public reset(): void {
    this.bsModalRef.hide();
    this.subject.next({custom: false, cancel: false, yaxis: []});
    this.subject.complete();
  }

  public unlockAxis(axis: {min: number, max: number, title: string, locked?: boolean}) {
    axis.locked = !axis.locked;
  }

  public confirm(): void {
    const formattedYAxisValues = this.yAxisData.map(y => ({
      min: !y.locked ? null : Number(y.min),
      max: !y.locked ? null : Number(y.max),
      title: y.title
    }))
    this.bsModalRef.hide();
    this.subject.next({custom: this.yAxisData.some(y => y.locked), cancel: false, yaxis: formattedYAxisValues});
    this.subject.complete();
  }

}
